import { DisplayTime } from 'common/display-state/display-time.js';
import { HTMLRenderer } from 'common/html-renderer.js';
import { IMapSlotClose, TitleBodyHeaderEl } from 'common/tile/tile-body-header-v2-element.js';
import { Tile } from 'common/tile/tile.js';
import { InlineWarningFactory as Warning } from 'common/warning/warning-inline-warnings-factory.js';
import { useNavigate } from 'react-router-dom';
import { IModule } from 'redux-state/layout/types.js';
import { ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { LinkFakeRef } from '../../condition/link-ref.js';

interface IHighSeasBulletin {
  issuedAt?: string;
  warningLocation?: ILocationWarningType;
  text?: string;
}

/** http://localhost:8080/marine/high-seas?location=subtropic */
export const HighSeasBulletin = ({ config }: IModule<IHighSeasBulletin & IMapSlotClose>) => {
  const navigate = useNavigate();

  const { title, link, warningLocation, text, issuedAt, onModuleClose } = config;

  // This regex captures the word following the '#' symbol
  const match = link?.url ? link.url.match(/#(\w+)/) : undefined;
  const firstMatch = match?.[1];

  return (
    <Tile dataModule="high-seas-bulletin" config={config}>
      <div className="Tile-body">
        <div className="Tile-body-header">
          <TitleBodyHeaderEl title={title} onModuleClose={onModuleClose} displaySmallHeader={true} />
        </div>
        <div className="Tile-body-content">
          {warningLocation && <Warning location={warningLocation} />}

          {text && <HTMLRenderer content={text || ''} classes="u-mB-xs" />}

          {issuedAt && (
            <p className="fineprint u-textGrey u-mT-0 u-mB-0">
              Issued:
              <DisplayTime date={issuedAt} />
            </p>
          )}
        </div>
        <LinkFakeRef
          label={link?.label}
          onClickCB={() => navigate(`${location.pathname}${location.search}#${firstMatch}`)}
        />
      </div>
    </Tile>
  );
};
